const QueryParameter = {
  getUrlParameter: (name: string) => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  getParamAfterSlash: () => {
    const afterSlashChars = window.location.pathname.match(/\/([^/]+)\/?$/);
    if (afterSlashChars !== null) {
      return afterSlashChars[1];
    }
    return '';
  },

  getParameterByName: (name: string, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
};

export default QueryParameter;
